import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { mdmsApi } from '@/api/mdmsApi';

/**
 * Store del MDM seleccionado en el header del panel.
 * Persiste en localStorage Y en BD (via set-default endpoint).
 */
export const DEFAULT_TZ = 'America/Argentina/Buenos_Aires';

interface MdmContextState {
  currentMdmId: number | null;
  currentMdmName: string | null;
  /** Zona horaria del MDM activo — todas las fechas del panel se muestran en esta zona. */
  currentMdmTimeZone: string;
  setMdm: (id: number, name: string, timeZone?: string, persistServer?: boolean) => void;
  setTimeZone: (tz: string) => void;
  clear: () => void;
}

export const useMdmContextStore = create<MdmContextState>()(
  persist(
    (set) => ({
      currentMdmId: null,
      currentMdmName: null,
      currentMdmTimeZone: DEFAULT_TZ,
      setMdm: (id, name, timeZone, persistServer = true) => {
        set({ currentMdmId: id, currentMdmName: name, ...(timeZone ? { currentMdmTimeZone: timeZone } : {}) });
        if (persistServer) {
          mdmsApi.setDefault(id).catch(() => {
            // Fallo silencioso — localStorage ya tiene el valor
          });
        }
      },
      setTimeZone: (tz) => set({ currentMdmTimeZone: tz || DEFAULT_TZ }),
      clear: () => set({ currentMdmId: null, currentMdmName: null, currentMdmTimeZone: DEFAULT_TZ }),
    }),
    {
      name: 'mdm-context-store',
    },
  ),
);
